export enum Decision {
    BackgroundColor = 'backgroundColor',
    Color = 'color',
    BorderColor = 'borderColor',

    /** @deprecated */
    Opacity = 'opacity',
    /** @deprecated */
    FontFamily = 'fontFamily',
    /** @deprecated */
    FontSize = 'fontSize',
    /** @deprecated */
    LineHeight = 'lineHeight',
    /** @deprecated */
    FontWeight = 'fontWeight',
    /** @deprecated */
    PaddingLeft = 'paddingLeft',
    /** @deprecated */
    PaddingRight = 'paddingRight',
    /** @deprecated */
    BorderRadius = 'borderRadius',
    /** @deprecated */
    Height = 'height',
    /** @deprecated */
    Width = 'width',
    /** @deprecated */
    BorderWidth = 'borderWidth',
    /** @deprecated */
    BorderStyle = 'borderStyle',
    /** @deprecated */
    Gutter = 'gutter',
    /** @deprecated */
    HorizontalMargin = 'horizontalMargin',
    /** @deprecated */
    MaxWidth = 'maxWidth',
}
